import React from 'react';
import PromoOverview from './PromoOverview';

/** /once/vc/:code/overview -- QR บนรูป voucher ที่ CMS ออกให้ (views/voucher/VoucherManage.js) */
export default function VoucherOverview() {
  return <PromoOverview kind="voucher" />;
}
